import { Navigate, NavigateProps } from "react-router-dom";

export function Redirect({
    to, 
    replace, 
    state
}: NavigateProps) {
  
   return Navigate({
    to, 
    replace, 
    state
   });
}
